import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import RFQWizard from "@/pages/RFQWizard";
import SmartQuestions from "@/pages/SmartQuestions";
import RFQConfirmation from "@/pages/RFQConfirmation";
import RFQDetail from "@/pages/RFQDetail";
import BuyerOffers from "@/pages/BuyerOffers";
import PurchaseOrders from "@/pages/PurchaseOrders";
import PurchaseOrderDetail from "@/pages/PurchaseOrderDetail";
import Inspections from "@/pages/Inspections";
import InspectionDetail from "@/pages/InspectionDetail";
import FreightIQ from "@/pages/FreightIQ";
import FreightIQDetail from "@/pages/FreightIQDetail";
import Shipments from "@/pages/Shipments";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Documents from "@/pages/Documents";
import DocumentDetail from "@/pages/DocumentDetail";
import WorkspaceDashboard from "@/pages/WorkspaceDashboard";
import WorkspaceAccess from "@/pages/WorkspaceAccess";
import WorkspaceLogin from "@/pages/WorkspaceLogin";

function App() {
  return (
    <div className="App min-h-screen text-neutral-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/rfq/new" element={<RFQWizard />} />
          <Route path="/rfq/:id/questions" element={<SmartQuestions />} />
          <Route path="/rfq/:id/confirmation" element={<RFQConfirmation />} />
          <Route path="/rfq/:id" element={<RFQDetail />} />
          <Route path="/access" element={<WorkspaceAccess />} />
          <Route path="/workspace/login" element={<WorkspaceLogin />} />
          <Route path="/workspace" element={<WorkspaceDashboard />} />
          <Route path="/workspace/rfq/:id/offers" element={<BuyerOffers />} />
          <Route path="/workspace/purchase-orders" element={<PurchaseOrders />} />
          <Route path="/workspace/purchase-orders/:poId" element={<PurchaseOrderDetail />} />
          <Route path="/workspace/inspections" element={<Inspections />} />
          <Route path="/workspace/inspections/:inspectionId" element={<InspectionDetail />} />
          <Route path="/workspace/freightiq" element={<FreightIQ />} />
          <Route path="/workspace/freightiq/:shipmentId" element={<FreightIQDetail />} />
          <Route path="/workspace/shipments" element={<Shipments />} />
          <Route path="/workspace/shipments/:shipmentId" element={<ShipmentDetail />} />
          <Route path="/workspace/documents" element={<Documents />} />
          <Route path="/workspace/documents/:documentId" element={<DocumentDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
